import { IconButton, ListItem, Status } from '@yaradigitallabs/ahua-react';
import type { SoftTag } from '../utils/match-maker.types';

interface SelectedSoftTagListItemProps {
  item: SoftTag;
  onRemove?: (item: SoftTag) => void;
  onReorder?: (id: string) => void;
  onDragStart?: (id: string) => void;
  onDragEnd?: () => void;
  isDragging?: boolean;
}

export const SelectedSoftTagListItem = ({
  item,
  onRemove,
  onReorder,
  onDragStart,
  onDragEnd,
  isDragging = false,
}: SelectedSoftTagListItemProps) => {
  return (
    <ListItem className={isDragging ? 'opacity-50' : ''}>
      <ListItem.BodyTail divider>
        <ListItem.Body>
          <div className="flex flex-row items-center gap-4">
            <div className="flex flex-row items-center gap-2">
              <Status size="n" colorType="gray">
                {item.priority}
              </Status>
              {item.priority === 1 && (
                <Status size="n" colorType="purple">
                  Primary
                </Status>
              )}
            </div>
            <ListItem.Subtitle>{item.tag_name}</ListItem.Subtitle>
          </div>
        </ListItem.Body>
        <ListItem.Tail>
          <IconButton
            icon="Delete"
            aria-label="Remove soft tag"
            onClick={() => onRemove?.(item)}
          />
          <span
            draggable
            onDragStart={event => {
              event.dataTransfer.effectAllowed = 'move';
              onDragStart?.(item.timeseries_id);
            }}
            onDragEnd={onDragEnd}
            className="cursor-grab active:cursor-grabbing"
          >
            <IconButton
              icon="Reorder"
              aria-label="Reorder soft tag"
              onClick={() => onReorder?.(item.timeseries_id)}
            />
          </span>
        </ListItem.Tail>
      </ListItem.BodyTail>
    </ListItem>
  );
};
